/**
 * Helper class designed to compare two objects 
 * and return the differences between them.
 *
 * @export
 * 
 * @class DiffChecker
 */
export default new class DiffChecker {
  /**
   * Class Constructor.
   * 
   * @memberof DiffChecker
   * 
   * @returns Void
   */
  construct() {
    this.resetDiff();
  }

  /**
   * Reset the diff to an empty object.
   * 
   * @memberof DiffChecker
   * 
   * @returns Void
   */
  resetDiff() {
    this.diff = {};
  }

  /**
   * Compares two objects and returns the differences between the two.
   * 
   * @memberof DiffChecker
   * 
   * @param {Object} firstObject
   * @param {Object} secondObject 
   * 
   * @returns Object
   */
  getObjectDiff(firstObject, secondObject) {
    this.resetDiff();

    for (let key in firstObject) {
      if (firstObject.hasOwnProperty(key)) {
        this.compareChanges(firstObject[key], secondObject[key], key);
      }
    }

    return this.diff;
  }

  /**
   * Compares two items and appends them to the diff object if they are not the same.
   * 
   * @memberof DiffChecker
   * 
   * @param {*} item1 
   * @param {*} item2 
   * @param {*} key 
   * 
   * @returns Void
   */
  compareChanges(item1, item2, key) {
    if (item1 !== item2) {
      this.diff[key] = item2;
    }
  }
}